import { render, staticRenderFns } from "./Fyxm.vue?vue&type=template&id=4f2af931&scoped=true"
import script from "./Fyxm.vue?vue&type=script&lang=js"
export * from "./Fyxm.vue?vue&type=script&lang=js"
import style0 from "./Fyxm.vue?vue&type=style&index=0&id=4f2af931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2af931",
  null
  
)

export default component.exports